import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";

const ManageSubadmin = () => {

  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <h1>Manage Sub-Admin</h1>
               <SubadminListTopbar />
      </div>
      
      <div className="cards table_cards v2">
 
        <SubadminList />
      </div>
    </MainContainer>
  );
};

export default ManageSubadmin;
